import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import LogoPreloader from './components/Logopreloader';
import Home from './pages/Home';
import OurWorkPage from './pages/OurWorkPage';
import AboutPage from './pages/AboutPage';
import Service from './pages/Service';
import PortfolioAdmin from './pages/PortfolioAdmin';
import TrackerApp from './pages/tracker';
import ThankYou from './components/ThankYou';

function AppContent() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  // Reset loading state when navigating away from home
  useEffect(() => {
    if (location.pathname === '/') {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [location.pathname]);

  if (isLoading && location.pathname === '/') {
    return (
      <LogoPreloader
        text="S I N T X"
        loop={false}
        onFinish={() => setIsLoading(false)}
      />
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/portfolio" element={<OurWorkPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/service" element={<Service />} />
      <Route path="/admin" element={<PortfolioAdmin />} />
      <Route path="/tracker_app" element={<TrackerApp />} />
      <Route path="/thankyou" element={<ThankYou />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;